import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing8,
  spacing24,
  spacing16,
  spacing12,
} from 'approot/shared/styles/spacing.style';
import { PStyled } from 'approot/shared/styles/typography.style';
import { baseFlexCss } from 'approot/shared/styles/flex.style';
import { grey5 } from 'approot/shared/styles/colours.style';
import {
  ActivitySettingsCheckpoint,
  ActivitySettingsCheckpointProps,
} from './activity.style';

export const ActivityPrint = styled.div`
  ${baseFlexCss}
  margin-bottom: ${rem(spacing16)};
  position: relative;
`;

export const ActivityPrintDifferentiation = styled.div`
  position: relative;
`;

export const ActivityPrintText = styled(PStyled).attrs({
  marginBottom: 0,
})`
  margin-left: ${rem(spacing12)};
  margin-right: ${rem(spacing24)};
`;

export const ActivityPrintCheckpoint = styled(
  ActivitySettingsCheckpoint
)<ActivitySettingsCheckpointProps>`
  position: absolute;
  right: -${rem(spacing8)};
  top: -${rem(2)};

  path {
    stroke: ${grey5};
  }
`;
